import { HostHandshake } from '../Handshake';
import { AbstractHostEndpoint } from './AbstractEndpoint';
import { HostChannel } from '../HostChannel';

// TODO: endpoint
export class IFrameHostEndpoint extends AbstractHostEndpoint {
  static connect(
    iframe: HTMLIFrameElement,
    cb: (transport: HostChannel) => void,
  ) {
    const host = new IFrameHostEndpoint(iframe);

    host.onConnect((port) => {
      const instance = new HostChannel(port);
      cb(instance);
    });
  }

  handshake: HostHandshake;

  constructor(private iframe: HTMLIFrameElement) {
    super();

    this.handshake = new HostHandshake(
      (message, port) => {
        if (port) {
          this.iframe.contentWindow?.postMessage(message, '*', [port]);
        } else {
          this.iframe.contentWindow?.postMessage(message, '*');
        }
      },
      (listener) => {
        globalThis.addEventListener('message', listener);
      },
    );
  }
}
